export const FILE_ADDED = 'FILE_ADDED';
export const FILE_REMOVED = 'FILE_REMOVED';
